import React from 'react';  // import the React library
import '../App.css'; // import your CSS file
import { motion } from 'framer-motion';
import BioLine from '../articleComponents/bioLine.js'; // import your CSS file
import Connect from '../articleComponents/connect';
import SocialMedia from '../articleComponents/SocialMedia';
import MetaTags from '../mainPageComponents/MetaTags';
import FullDay from "../images/a-full-day.jpg";
import Image from '../mainPageComponents/image.js';
import TraversePosts from '../articleComponents/navigation';

const today = new Date("1, 3, 2021").toLocaleDateString('en-US', {  
  day:   'numeric',
  month: 'short',
  year:  'numeric',
  weekday: 'long'
});

function noFearOfDating() {
    return (
        <motion.div className="articleStyle"
        initial={{ opacity: 0 }}
animate={{opacity: 1 }}
exit={{ opacity: 0}}
transition={{duration: .4}}
>

<MetaTags title="Overcoming My Fear of Dating" desc="Here is my journey into the dating game, trying to figure out how to use the Date() Object and apply what I want to see onto Highway 60." 
URL="https://highway-60.firebaseapp.com/articles/the-dating-game" imageURL={FullDay} />

        <h1>Overcoming My Fear of Dating</h1>

<Image picURL={FullDay} />

<BioLine />
<p>{today}</p>


<div style={{textAlign: "left", marginTop: "5px", marginBottom: "20px"}}>
<SocialMedia url="https://highway-60.firebaseapp.com/articles/the-dating-game" title="Overcoming My Fear of Dating" hashtag="#highway60" hashtagArray={["marketing", "writing", "coding"]} 
via="TheHighway60" desc="Here is my journey into the dating game, trying to figure out how to use the Date() Object and apply what I want to see onto Highway 60." />
</div>

    <p>I saw the most amazing cartoon. It summarizes my path to programming. It is a comic with four boxes. It’s about a programmer. It starts: <i>This is what my friends think I do.</i> There is a picture of him designing a rocket ship. </p>

<p>
The next bx reads: <i>This is what my parents think I do</i>. There is a picture of him designing a submarine. Then, <i>this is what I think I do.</i> There is a picture of the universe and him decoding it. 
</p>

<p>
The final box reads, <i>this is what I actually do</i>. 
</p>

<p>
Inside the box is a picture of a google search bar with search text that reads:
</p>

<p>
<i>How to make a date function in JavaScript.</i>
</p>

<p>
The kicker was that the Date() function was exactly what I was working on and I must have googled something similar about 20 times. 
</p>

<h1>
Fifty First Dates
</h1>

<p>
For whatever reason, my fear of dates is that whenever I call the function, the current date appears. This is good for a home page where I can impress my friends with a date that stays current every time they see the page, but what about past blogs?
</p>

<p>
I have this fear that if I just put a &#60;p&#62;&#123;date()&#125;&#60;/p&#62; in my blog page, every single blog post will tell the user that it was done on the same day.
</p>

<p>
Fortunately, googling the Date() function worked. 
</p>

<p>
Rabbi Google reintroduced me to parameters. 
</p>

<p>
(Shout out to <a href="https://www.youtube.com/user/nissimworld">Nissim Black</a> on that one. He talks about his path to spirituality by learning about religion through Rabbi Google, searching for everything he could find online. I like the term. I think I will use it, but it’s only fair to give credit where it is due.)
</p>

<iframe width="560" height="315" src="https://www.youtube.com/embed/NJzEqTD2X7Y?start=20" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

<p>
Back to our regularly scheduled broadcast. 
</p>

<p>
I am pleased to announce that I have dates installed in my blog posts, as you can see up top!
</p>

<p>
The problem is that it takes about 70 lines of code to make it happen. I have to put a new Date() object into a variable, then set the day, month, and year. Then I need 2 switch() functions to convert the month from a number into a name and the same for a day. 
</p>

<p>
This is pure JavaScript. I cannot put it into a component and call it with some props. 
</p>

<p>
Someone probably can do this, but he is too busy earning NIS 18,000 ($5,000) a month developing something. 
</p>

<h1>Injecting JavaScript</h1>

<p>
First things first. After consulting Rabbi Google, I found some really nice code to make my date:
</p>


<div style={{textAlign: "left", marginLeft: "15%", fontSize: "1.25em"}}>
    <br />
<code>{`
const today = new Date("Dec 3 2020").toLocaleDateString('en-US', {  
`}</code><br />
<br />
<code>{`
    day:   'numeric',
`}</code><br />
<br /><code>{`
    month: 'short',
`}</code><br />
<br /><code>{`
   year:  'numeric',
`}</code><br />
<br /><code>{`
    weekday: 'long'
`}</code><br />
<br /><code>{`
});
`}</code><br />
<br />
</div>

<p>
    This isn’t long, certainly not 70 lines worth. 
    </p>

<p>
The no-brainer decision is to just use this for every article post. 
</p>

<p>
I tried taking this simple task and turning it into a function that I can call at will, but it didn’t work. It will have to wait for another day, G-d willing, in the not too distant future. 
</p>

<h1>
While We Are on the Subject of Dating
</h1>

<p>
The other day I forgot to take out the garbage. My wife, already busy with a thousand tasks, now has to lug a 10-kilo bag of stink with her 300 meters to the dumpster. 
</p>

<p>
Needless to say, I am gonna get it. 
</p>

<p>
Trying to make her feel better, I say to her,
</p>

<p>
“I love you with all my heart.”
</p>

<p>
She says, “Good. Now love me with all your brains.”
</p>


<TraversePosts prevURL="/articles/a-big-decision" nextURL="/articles/put-on-your-helmet"/>

<Connect />
</motion.div>
  );
}

export default noFearOfDating;
